import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";

import Sidebar from "react-sidebar";

import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";

import Logo from "./buttons/Logo";
import TopNavBar from "./TopNavBar";
import ShortcutsMenu from "./ShortcutsMenu";
import SidenavMenu from "./SidenavMenu";

import centuryLogoSrc from "../../images/Century-Logo-2020-jaune-RVB.png";

import "./siteHeader.scss";
import { Icon } from "../primitives";
import SearchBar from "../search/SearchBar";
import AnnouncementBar from "../layout/announcementBar/AnnouncementBar";
import { CartDrawer } from "@sbi-international/boutik.gatsby.plugin.checkout";
import { faXmarkLarge } from "@fortawesome/pro-solid-svg-icons";

const isBrowser = typeof window !== "undefined";

export default function SiteHeader() {
    const [sidebarOpen, onSetSidebarOpen] = useState<boolean>(false);
    const [productOpen, setProductOpen] = useState<boolean>(false);
    const [partOpen, setPartOpen] = useState<boolean>(false);
    const [supportOpen, setSupportOpen] = useState<boolean>(false);
    const [searchOpen, setSearchOpen] = useState<boolean>(false);
    const [urlAddressOpen, setUrlAddressOpen] = useState<boolean>(false);

    const { currentLocale } = usePageLocalization();

    const { messages } = useStaticQuery(
        graphql`
            query {
                messages: allProductsJson(filter: { code: { eq: "message" } }) {
                    nodes {
                        title {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        `
    );

    if (isBrowser) {
        if (window.innerHeight < window.outerHeight) {            
            !urlAddressOpen && setUrlAddressOpen(true);
        } else {
            urlAddressOpen && setUrlAddressOpen(false);
        }
    }

    return (
        <>
            <Sidebar
                rootClassName="sidenav"
                sidebarClassName="sidenavContent"
                contentClassName="sidenavHeader"
                overlayClassName="sidenavOverlay"
                sidebar={
                    <SidenavMenu
                        onSetSidebarOpen={onSetSidebarOpen}
                        productOpen={productOpen}
                        setProductOpen={setProductOpen}
                        partOpen={partOpen}
                        setPartOpen={setPartOpen}
                        supportOpen={supportOpen}
                        setSupportOpen={setSupportOpen}
                    />
                }
                open={sidebarOpen}
                onSetOpen={(open) => onSetSidebarOpen(open)}
            >
                <header>
                    <div className="aboveMenu">
                        <div className="hamburger-menu">
                            <Icon
                                d="M 6 9 A 2.0002 2.0002 0 1 0 6 13 L 42 13 A 2.0002 2.0002 0 1 0 42 9 L 6 9 z M 6 22 A 2.0002 2.0002 0 1 0 6 26 L 42 26 A 2.0002 2.0002 0 1 0 42 22 L 6 22 z M 6 35 A 2.0002 2.0002 0 1 0 6 39 L 42 39 A 2.0002 2.0002 0 1 0 42 35 L 6 35 z"
                                size="24"
                                viewBox="0 0 48 48"
                                onClick={() => onSetSidebarOpen(true)}
                            />
                        </div>
                        <div className="left-align">
                            <Logo logoSrc={centuryLogoSrc} />
                        </div>
                        <div className="center-align">
                            <SearchBar />
                        </div>
                        <div className="right-align">
                            <ShortcutsMenu searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
                        </div>
                    </div>

                    <TopNavBar />

                    {searchOpen && <SearchBar />}

                    {messages?.nodes.length ? (
                        <div className="belowMenu">
                            <AnnouncementBar>
                                {messages.nodes[0].title[currentLocale]}
                            </AnnouncementBar>
                        </div>
                    ) : null}
                </header>
            </Sidebar>
            <div className={`${urlAddressOpen ? "url-open" : "url-close"}`}>
                <CartDrawer iconCloseBtn={faXmarkLarge} />
            </div>
        </>
    );
}
